import * as types from "./types";

export function changeAppBarTitle(title) {
    // const newTitle = "SKA Suite™ | Reception Desk 3 | " + title;
    const newTitle = title;
    return {
        type: types.SET_APPBAR_TITLE,
        title: newTitle
    };
}

export function changeLanguage(language) {
    return {
        type: types.SET_APP_LANGUAGE,
        language: language
    };
}

export function closeDrawer() {
    return {
        type: types.CLOSE_DRAWER
    };
}

export function closeAllMenus() {
    return {
        type: types.CLOSE_ALL_MENUS
    };
}

export function openDrawer() {
    return {
        type: types.OPEN_DRAWER
    };
}

export function toggleMonitoringMenu() {
    return {
        type: types.TOGGLE_MONITORING_MENU
    };
}

export function toggleCreationMenu() {
    return {
        type: types.TOGGLE_CREATION_MENU
    };
}

export function toggleDashboardMenu() {
    return {
        type: types.TOGGLE_DASHBOARD_MENU
    };
}

export function toggleDataMenu() {
    return {
        type: types.TOGGLE_DATA_MENU
    };
}

export function toggleDeploymentMenu() {
    return {
        type: types.TOGGLE_DEPLOYMENT_MENU
    };
}

export function toggleSecurityMenu() {
    return {
        type: types.TOGGLE_SECURITY_MENU
    };
}

export function toggleAdministrationMenu() {
    return {
        type: types.TOGGLE_ADMIN_MENU
    };
}

export function toggleURLCallsMenu() {
    return {
        type: types.TOGGLE_URLCALLS_MENU
    };
}

export function toggleCarouselMenu() {
    return {
        type: types.TOGGLE_CAROUSEL_MENU
    };
}

export function toggleOrganisationMenu() {
    return {
        type: types.TOGGLE_ORGANISATION_MENU
    };
}

export function toggleSysAdminMenu() {
    return {
        type: types.TOGGLE_SYS_ADMIN_MENU
    };
}

export function ChangeCurrentMenuName(name) {
    return {
        type: types.CHANGE_CURRENT_MENU_NAME,
        name: name
    };
}

export function isActiveMinify() {
    return {
        type: types.IS_ACTIVE_MINIFY
    };
}


